module.exports = __webpack_public_path__ + "static/media/Instructions.84f13e58.mp3";